"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJSONifiedStringOrGetRaw = void 0;
var parseJSONifiedStringOrGetRaw = function (str) {
    return str.match(/^".+"$/) ? JSON.parse(str) : str;
};
exports.parseJSONifiedStringOrGetRaw = parseJSONifiedStringOrGetRaw;
